module.exports = __webpack_public_path__ + "static/media/iconic_brand.60724a3c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconic_brand.webp
// module id = 359
// module chunks = 0